// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__21XB9","colMin":"styles_colMin__YIe1z"};